'use strict';

function checkAnalytics() {
  let clientId;

  return () => {
    if (!window.ga) {
      return clientId;
    }

    window.ga &&
      window.ga(tracker => {
        clientId = tracker.get('clientId');
      });

    return clientId;
  };
}

module.exports = {
  checkAnalytics,
};
